import React from 'react'
import TextField from 'components/TextField'
import { IconButton, Tooltip } from '@mui/material'
import { Save } from '@mui/icons-material'
import { useContactForm } from 'components/ChatMessage/ContactForm/useContactForm'

const ContactForm = () => {
  const form = useContactForm()
  const { useFormField, submit, formState } = form
  const { isSubmitting } = formState

  return (
    <form onSubmit={submit}>
      <TextField
        {...useFormField('email', 'typing')}
        label="Email"
        endAdornment={(
          <Tooltip title="Save email">
            <IconButton type="submit" disabled={isSubmitting} size="large">
              <Save />
            </IconButton>
          </Tooltip>
        )}
      />
    </form>
  )
}

export default React.memo(ContactForm)
